import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "./lib/scroll";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { WhyUs } from "./components/WhyUs";
import { HowItWorks } from "./components/HowItWorks";
import { Pricing } from "./components/Pricing";
import { Technology } from "./components/Technology";
import { Gallery } from "./components/Gallery";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="bg-obsidian text-white font-sans antialiased">
            <div className="grain" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <WhyUs />
                <HowItWorks />
                <Pricing />
                <Technology />
                <Gallery />
                <Faq />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;
